//

window.mcb.mobileAccordion = (function () {
    // Private variables
    const selectorContainer = '.mcp-mobile--accordion';
    const selectorTrigger = selectorContainer + ' .mcp-block--title button';
    const attributeName = 'aria-expanded';
    let resizeTimeout;
    const resizeMatchingWidthsObserver = new ResizeObserver(entries => {
        if (resizeTimeout) {
            clearTimeout(resizeTimeout);
        }

        resizeTimeout = setTimeout(() => {
            const isMobile = window.innerWidth < 600;
            for (let entry of entries) {
                const current = entry.target.getAttribute(attributeName);
                if (current === null) {
                    entry.target.setAttribute(attributeName, !isMobile);
                }
            }
        }, 10);
    });

    // Initialize mobile accordions
    let targets = document.querySelectorAll(selectorContainer);
    targets.forEach(element => {
        resizeMatchingWidthsObserver.observe(element);
    });

    document.querySelectorAll(selectorTrigger).forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            const target = e.target.closest(selectorContainer);
            const current = target.getAttribute(attributeName).toString();
            const inverse = current === "false";
            target.setAttribute(attributeName, inverse);
        });
    });

    // This module has no public interface
})();
